import { Heading, Img } from "../../components";
import React from "react";

const projects = [
  {
    name: "Caro",

  }
]

export default function Projects() {
  return (
    <section id="workexperience" className="container-xs flex min-h-screen">
      <div className="flex flex-col  w-full">
        <div className="flex flex-col gap-8">
          <Heading size="heading2xl" as="h1" className="text-[96px] font-bold text-white-a700 md:text-[48px]">
            <span className="text-white-a700">Projects</span>
            <span className="text-orange-a200">.</span>
          </Heading>
          <div className="grid grid-cols-3 gap-4">
            <div className="grid grid-rows-3 gap-4">
              <div className=" bg-slate-700 rounded-[50px] py-2 px-3">
                <Heading as="h2" className="text-center">
                  CARO
                </Heading>
              </div>
              <div className=" bg-slate-700 rounded-[50px] py-2 px-3">
                <Heading as="h2" className="text-center">
                  BLAZEGUARD
                </Heading>
              </div>
              <div className=" bg-slate-700 rounded-[50px] py-2 px-3">
                <Heading as="h2" className="text-center">
                  WALVOS
                </Heading>
              </div>
            </div>
            <div className="grid grid-rows-3 gap-4">
              <div className=" bg-slate-700 rounded-[50px] py-2 px-3">
                <Heading as="h2" className="text-center">
                  SLIDEHUB
                </Heading>
              </div>
              <div className=" bg-slate-700 rounded-[50px] py-2 px-3">
                <Heading as="h2" className="text-center">
                  BLAZEGUARD
                </Heading>
              </div>
            </div>
            <div className="grid grid-rows-3 gap-4">
              <div className=" bg-slate-700 rounded-[50px] py-2 px-3">
                <Heading as="h2" className="text-center">
                PASIMO
                </Heading>
              </div>
              <div className=" bg-slate-700 rounded-[50px] py-2 px-3">
                <Heading as="h2" className="text-center">
                WALVOS
                </Heading>
              </div>
            </div>
          </div>



        </div>
      </div>
    </section>

  );
}
